export default __webpack_public_path__ + "static/media/img-2.1c8fac61.png";